import React, { useState } from 'react';
import useDidMountEffect from 'assets/js/useDidMountEffect';

export default function ReportDetailReport(props) {
  const [detailList, setDetailList] = useState([]);

  useDidMountEffect(() => {
    let group = [];
    const orderList = [];

    let row = 0;

    for (let i = 0; i < props?.detailList?.length; i++) {
      const detail = props?.detailList[i];
      const rowSpan = detail.rowSpan;

      if (row + rowSpan <= 40) {
        group.push(detail);
      } else {
        orderList.push(group);
        group = [];
        group.push(detail);
      }

      row += rowSpan;
    }

    orderList.push(group);

    setDetailList(orderList);
  }, [props]);

  return (
    <>
      {detailList?.map(order => {
        return (
          <>
            <div className='page'>
              <div className='page-head'>
                <h4>Monthly Report - DETAIL REPORT</h4>
                <p>UNIVERSAL SOLUTION TECHNOLOGY</p>
              </div>
              <div className='page-content'>
                <section>
                  <div className='sec-content'>
                    <table className='detail-report'>
                      <colgroup>
                        <col width='9%'/>
                        <col width='9%'/>
                        <col width='11%'/>
                        <col width='11%'/>
                        <col width='9%'/>
                        <col width='11%'/>
                        <col width='14%'/>
                        <col width='26%'/>
                      </colgroup>
                      <thead>
                      <tr>
                        <th colSpan={3}>Service Summary</th>
                        <th colSpan={3}>Pest Occurrence</th>
                        <th colSpan={3}>Action Plan</th>
                      </tr>
                      <tr>
                        <th>Pest</th>
                        <th>Frequency</th>
                        <th>Date</th>
                        <th>Date</th>
                        <th>Number
                          <br/>
                          Trapped
                        </th>
                        <th>Location</th>
                        <th>By UST</th>
                        <th colSpan={2}>Recommended to Customer</th>
                      </tr>
                      </thead>
                      {order?.map((item) => (
                        <tbody className='pest-group'>
                        {item?.groupList?.map((detail, idx) => (
                          <>
                            {idx === 0 &&
                              <tr className='pests-item'>
                                <td rowSpan={parseInt(item.rowSpan)}>{item.pestsName}</td>
                                <td rowSpan={parseInt(item.rowSpan)}>
                                  <select defaultValue='default'>
                                    <option value='default'>--Select--</option>
                                    <option value='Daily'>Daily</option>
                                    <option value='Weekly' selected>Weekly</option>
                                    <option value='Monthly'>Monthly</option>
                                    <option value='Yearly'>Yearly</option>
                                  </select>
                                </td>
                                <td rowSpan={parseInt(item.rowSpan)}>
                                  <input type='text' id='date' name='date' defaultValue=''/>
                                </td>
                                <td>{detail.regDate}</td>
                                <td>{detail.pestsCnt}</td>
                                <td>{detail.patrolArea}</td>
                                <td rowSpan={parseInt(item.rowSpan)}>
                                  <input type='text' id='byUst' name='byUst' placeholder='Enter your details'/>
                                </td>
                                <td rowSpan={parseInt(item.rowSpan)}>
                                  <input type='text' id='recommend' name='recommend' placeholder='Enter your details'/>
                                </td>
                              </tr>
                            }
                            {idx !== 0 &&
                              <tr className='rowSpan'>
                                <td>{detail.regDate}</td>
                                <td>{detail.pestsCnt}</td>
                                <td>{detail.patrolArea}</td>
                              </tr>
                            }
                          </>
                        ))}
                        </tbody>
                      ))}
                    </table>
                  </div>
                </section>
              </div>
            </div>
          </>
        )
      })}
    </>
  )
}